import appLocaleData from 'react-intl/locale-data/ja';
import messages from './messages.js';
import antd from 'antd/lib/locale-provider/ja_JP.js';
import 'moment/locale/ja';

const fixAntd = JSON.parse(JSON.stringify(antd));
fixAntd.DatePicker.timePickerLocale.placeholder = '日付を選択して下さい';

export default {
    // 合并所有 messages，加入 antd 组件的 messages
    messages: {
        ...messages,
    },

    antd: fixAntd,

    // locale
    locale: 'ja-JP',

    // react-intl locale-data
    data: appLocaleData,
};

